var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"route-unsubscribed\"><section class=\"padded\"><div class=\"container text-center\"><div class=\"row\"><div class=\"col-xs-12\"><h2>Sorry to see you go!</h2><br><p>You have been unsubscribed from all emails.</p></div></div></div></section></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/routes/unsubscribed-customer.jade
 ** module id = 3609
 ** module chunks = 3
 **/